import { ScrollPanel } from '@assets/component/Panel/ScrollPanel/ScrollPanel';
import { useStore } from '@assets/model/Store';
import { get, getDatabase, onValue, ref } from 'firebase/database';
import { marked } from 'marked';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import moment from 'moment';

export const DealFlowise = observer(() => {
    const store = useStore();
    const [reportData, setReportData] = useState(null);

    const show_deep_research = false;
    useEffect(() => {
        const companyId = store.selectedReportId;
        const report_type = store.query.report_has_pdf
            ? 'insight_report_with_cim'
            : 'insight_report_no_cim';
        const target = `report_runs/${report_type}/${companyId}`;
        const r = ref(getDatabase(), target);
        const unsub = onValue(r, data => {
            setReportData(data.val());
        });

        return () => unsub();
    }, []);

    //var dashboard_vars = [];
    var deep_research = [];
    var run_variables = [];

    // try {
    //     const vars = JSON.parse(data?.vars['final_report_flowise'].value);
    //     const var_keys = Object.keys(vars);
    //     dashboard_vars = var_keys.map(key => {
    //         return (
    //             <tr key={key} style={{ borderTop: '1px solid #ccc' }}>
    //                 <td valign="top">{key}</td>
    //                 <td>{vars[key]}</td>
    //             </tr>
    //         );
    //     });
    // } catch (e) {}

    if (reportData?.deep_research && show_deep_research) {
        const deepResearch = reportData.deep_research;
        let keys = Object.keys(deepResearch).sort();
        for (let k of keys) {
            const rawHtmlWithDefault = marked.parse(
                deepResearch[k]['results'] as string,
                { async: false }
            );
            let sanitizedHtml = DOMPurify.sanitize(
                rawHtmlWithDefault as string
            );
            deep_research.push(
                <tr key={k} style={{ borderTop: '1px solid #ccc' }}>
                    <td valign="top">{k}</td>
                    <td>
                        <div
                            style={{ maxWidth: '1200px' }}
                            dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
                        />
                    </td>
                </tr>
            );
        }
    }

    if (reportData?.vars) {
        const runVars = reportData.vars;
        let keys = Object.keys(runVars).sort();
        const parseData = s => {
            return moment(s.slice(0, 23));
        };

        keys.sort((a, b) => {
            const aDate = parseData(runVars[a]['updated_at']);
            const bDate = parseData(runVars[b]['updated_at']);
            return bDate.valueOf() - aDate.valueOf();
        });

        for (let k of keys) {
            const rawHtmlWithDefault = marked.parse(
                runVars[k]['value'] as string,
                { async: false }
            );

            const updatedAt = runVars[k]['updated_at'];
            const date = moment(updatedAt.slice(0, 23));

            let sanitizedHtml = DOMPurify.sanitize(
                rawHtmlWithDefault as string
            );
            run_variables.push(
                <tr key={k} style={{ borderTop: '1px solid #ccc' }}>
                    <td valign="top">{k}</td>
                    <td>
                        <div
                            style={{ maxWidth: '1200px' }}
                            dangerouslySetInnerHTML={{
                                __html: sanitizedHtml
                            }}
                        />
                    </td>
                    <td valign="top">{date.format('YYYY-MM-DD HH:mm:ss')}</td>
                </tr>
            );
        }
    }
    return (
        <ScrollPanel>
            {/* <h1>Dashboard Vars</h1>
            <table
                style={{
                    top: '50px',
                    position: 'relative'
                }}
            >
                <tbody>{dashboard_vars}</tbody>
            </table> */}

            <h1>Run Variables</h1>
            <table style={{ top: '50px', position: 'relative' }}>
                <tbody>{run_variables}</tbody>
            </table>

            <h1 style={{ marginTop: '100px' }}>Deep Research</h1>
            <table style={{ top: '50px', position: 'relative' }}>
                <tbody>{deep_research}</tbody>
            </table>
        </ScrollPanel>
    );
});
